import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import VueSweetalert2 from "vue-sweetalert2";

// router setup
import router from "./routes/router";
// plugin setup
Vue.use(VueSweetalert2);
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
});
